import api from "./core";

const basePath = "api/{{serverSegment}}/PrnMedication";

export default {
  get(id) {
    return api.get(`${basePath}/${id}`);
  },
  update(id, data) {
    return api.patch(`${basePath}/${id}`, data);
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`);
  },
  query(eocId, filter) {
    return api.post(`${basePath}/${eocId}`, filter);
  },
  create(data) {
    return api.put(`${basePath}`, data);
  },
  setValues(id, data) {
    return api.patch(`${basePath}/${id}/SetValues`, data);
  },
  deleteMultiple(ids) {
    return api.patch(`${basePath}/DeleteAll`, ids);
  }
};
